import { render } from "./EmpReqLead.vue?vue&type=template&id=9ab61216"
import script from "./EmpReqLead.vue?vue&type=script&lang=js"
export * from "./EmpReqLead.vue?vue&type=script&lang=js"

import "./EmpReqLead.vue?vue&type=style&index=0&id=9ab61216&lang=css"

import exportComponent from "C:\\pythonproject0\\tkrforntend\\tkrforntend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__